import LinkToDocusaurus from '../LinkToDocusaurus'
import { testCaseDashboard } from '../../docs-routes'

const LinkToTestCaseDashboardDoc = () =>
  <LinkToDocusaurus path={testCaseDashboard}>
    Learn more about Test Case Dashboard
  </LinkToDocusaurus>

export default LinkToTestCaseDashboardDoc
